module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_yoso_studio_plus-8f4befee43e7b5dd3b2171c374b70d90.jpg";